import { jsx as _jsx } from "react/jsx-runtime";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useMemo, useCallback } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { parseISO, isValid } from 'date-fns';
import { cs } from 'date-fns/locale';
const ConditionValueDateTimePicker = ({ control, andConditionsIndex, orConditionsIndex, }) => {
    const value = useWatch({
        control,
        name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.value`,
    });
    // Convert ISO string to Date object for DateTimePicker
    const dateValue = useMemo(() => {
        if (!value)
            return null;
        if (typeof value === 'string') {
            const parsed = parseISO(value);
            return isValid(parsed) ? parsed : null;
        }
        // Check if value is a Date object
        const dateObj = value;
        if (dateObj && typeof dateObj === 'object' && dateObj instanceof Date) {
            return isValid(dateObj) ? dateObj : null;
        }
        return null;
    }, [value]);
    const handleChange = useCallback((newValue, onChange) => {
        // Convert Date object to ISO string for form
        if (newValue instanceof Date) {
            onChange(newValue.toISOString());
        }
        else {
            onChange('');
        }
    }, []);
    if (!control) {
        return null;
    }
    return (_jsx(LocalizationProvider, { dateAdapter: AdapterDateFns, adapterLocale: cs, children: _jsx(Controller, { control: control, name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.value`, render: ({ field }) => (_jsx(DateTimePicker, { value: dateValue, onChange: (newValue) => handleChange(newValue, field.onChange), slotProps: {
                    textField: {
                        variant: 'outlined',
                        size: 'small',
                        InputLabelProps: {
                            shrink: true,
                        },
                    },
                } })) }) }));
};
export default ConditionValueDateTimePicker;
//# sourceMappingURL=ConditionValueDateTimePicker.js.map